import { LoginCallback } from '@okta/okta-vue'

const oktaRouter = [
  {
    name: "Logout",
    path : '/logout',
  },
  {
    path: '/login/callback',
    component: LoginCallback,
  },
] 

export default oktaRouter
